<template>
	<div class="block block-rounded shadow-sm overflow-hidden">
		<div class="block-content block-content-full p-0">
			<img
				src="/media/banners/gold_lifetime_membership.jpg"
				alt="TRC Gold Lifetime Membership"
				class="w-100 gold-lifetime-banner"
			/>
		</div>
		<div class="block-content block-content-full p-4 p-md-5">
			<div class="row justify-content-center">
				<div class="col-lg-10 col-xl-9 gold-lifetime-copy">
					<p class="text-uppercase fw-semibold text-primary mb-2">Bro. Bo's 60th Birthday Treat</p>
					<h1 class="h2 mb-3">A Special 60th Birthday Treat: Lifetime Gold Membership</h1>
					<p class="lead">
						Secure TRC Gold Lifetime Membership by July 17, 2026, and be among the first 60 invited to dinner with Bro. Bo.
					</p>

					<p>Hi friend,</p>
					<p>I'm turning 60 years old.</p>
					<p>Wow.</p>
					<p>Imagine that.</p>
					<p>Let me become sentimental for a moment. I think about the past years that have gone by, the memories, and how good God has been towards me and my family. Now, I'm starting my journey towards becoming a senior citizen. And yes, I'm excited to have senior citizen discounts soon!</p>
					<p>Kidding aside.</p>
					<p>One of the treasures God has given me is the TrulyRich Club.</p>
					<p>This community that I founded years ago continues with its mission of helping you achieve financial freedom.</p>
					<p>And for my 60th Birthday this year we're having a celebration!</p>
					<p>For the first 60 who secure our TRC Gold Lifetime Membership, the dinner is on me! (one time only)</p>
					<p>I'm excited about the deeper kwentuhan we'll have. Slots are very limited to the first 60 because I want our dinner to be personal and close-knit.</p>
					<p>Did you know how I got the idea of the TRC Lifetime Gold Membership?</p>
					<p>It's because from time to time I encounter TRC members who would like to become members forever!</p>
					<p>I got blown away by that suggestion. And that means many have been blessed by our financial community that they want to secure their spot in TRC for a lifetime!</p>
					<p>Imagine... No renewals. No missed seats. Just guaranteed access, premium privileges, and lifelong savings.</p>
					<p>Just pure, uninterrupted access to everything the TrulyRichClub offers, year after year after year, for the rest of your life.</p>

					<h2 class="h4 mt-4">Here's everything included in your one-time investment:</h2>
					<ul>
						<li>Lifetime Access to TRC Premium Tools - Stock Alerts, Wealth Strategies, and Market Updates, with no expiry</li>
						<li>1 Free Diamond Event Ticket every year</li>
						<li>1 Free Platinum Event Ticket every year</li>
						<li>5 Free Tickets to TRC Wealth Conference annually</li>
						<li>Premium Seating & Early Access to WealthCon classes</li>
						<li>You can attend any How to Make Millions in the Stock Market Seminar for free</li>
						<li>You can attend any Truly Rich Coffee Club session for free</li>
						<li>Exclusive 1-on-1 with Bro. Bo - choose between a personal breakfast (first come, first served) or a 30-minute Zoom session</li>
						<li>One-Time Payment, Lifetime Savings - never pay annual fees again, saving you more as the years go by</li>
					</ul>

					<div class="rounded bg-body-light p-4 my-4">
						<p class="mb-2">The Truly Rich Club Gold Lifetime Membership is valued at Php 135,000.</p>
						<p class="h4 mb-2">Birthday special: Php 114,000.00</p>
						<p class="mb-0">Available from July 3 to 17, 2026 only. You also have 365 days for a full refund. No questions asked.</p>
					</div>

					<a :href="checkout_url" class="btn btn-primary btn-lg mb-4">
						Sign me up for TRC Gold Lifetime Membership
					</a>

					<p>Unlock permanent peace of mind and a definitive step towards securing your abundance journey with me and our supportive community.</p>
					<p>This is more than a membership. It's a legacy investment.</p>
					<p>May you become truly rich,</p>
					<p>Bo Sanchez<br/>TrulyRichClub Founder</p>

					<a :href="checkout_url" class="btn btn-primary btn-lg">
						Yes, count me in your 60th Birthday Bro. Bo!
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import GuestLayout from '../Layouts/GuestLayout'

	export default {
		layout: GuestLayout,
		props: {
			checkout_url: {
				type: String,
				default: '/checkout/gold?c=bday60&is_lt',
			},
		},
	}
</script>

<style scoped>
	.gold-lifetime-banner {
		max-height: 320px;
		object-fit: cover;
		object-position: center;
	}

	.gold-lifetime-copy p,
	.gold-lifetime-copy li {
		font-size: 1.05rem;
		line-height: 1.7;
	}

	.gold-lifetime-copy ul {
		padding-left: 1.25rem;
	}

	.gold-lifetime-copy li {
		margin-bottom: 0.5rem;
	}
</style>
